import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, GetItemsCreatedFromResponseAnswerDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetCreatedItemsFromResponseAnswerRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getCreatedItemsFromResponseAnswerRequest({
    queryKey,
  }: QueryFunctionContext<
    ReturnType<typeof queryKeys.surveys.getItemsCreatedFromResponseAnswer>
  >): Promise<GetItemsCreatedFromResponseAnswerDto> {
    const accessToken = await getAccessToken();
    const [{ responseAnswerGuid }] = queryKey;

    const url = new URL(`${configuration.apiRootUrl}/survey-response-answer/${responseAnswerGuid}/created-items`);

    const response = await fetch(url.href, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getCreatedItemsFromResponseAnswerRequest };
};

const useGetCreatedItemsFromResponseAnswer = (responseAnswerGuid: string, enabled: boolean = true) => {
  const { getCreatedItemsFromResponseAnswerRequest } = useGetCreatedItemsFromResponseAnswerRequest();

  return useQuery({
    queryKey: queryKeys.surveys.getItemsCreatedFromResponseAnswer(responseAnswerGuid),
    queryFn: getCreatedItemsFromResponseAnswerRequest,
    enabled: enabled,
  });
};

export { useGetCreatedItemsFromResponseAnswer };
